// Service worker registration + install prompt + local notifications

let deferredPrompt = null;

export function registerSW() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((err) => console.warn("SW register failed:", err));
    });
  }

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new CustomEvent("eeman-can-install"));
  });
}

export function canInstall() {
  return deferredPrompt !== null;
}

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return choice.outcome === "accepted";
}

/* ---------- Local daily reminder ---------- */
const LS_REMINDER = "eeman_reminder_time";

export function getReminderTime() {
  return localStorage.getItem(LS_REMINDER) || "";
}

export function setReminderTime(hhmm) {
  if (!hhmm) {
    localStorage.removeItem(LS_REMINDER);
    return;
  }
  localStorage.setItem(LS_REMINDER, hhmm);
}

export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  const result = await Notification.requestPermission();
  return result;
}

let _interval = null;
let _lastFired = "";

export function startReminderLoop() {
  if (_interval) clearInterval(_interval);
  _interval = setInterval(() => {
    const hhmm = getReminderTime();
    if (!hhmm) return;
    const now = new Date();
    const cur = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
    const key = `${now.toISOString().slice(0, 10)}-${hhmm}`;
    if (cur === hhmm && _lastFired !== key && Notification.permission === "granted") {
      _lastFired = key;
      navigator.serviceWorker?.controller?.postMessage({
        type: "daily-summary",
        body: "Tap to review today's sales, expenses and set tomorrow's rates.",
      });
    }
  }, 30000);
}
